import { PanKeeperForm } from '@namespace/pankeeper';
import { VoucherCodeField } from '../components/Deposit/PaymentForms/Abon/VoucherCodeField';

export const PAYMENT_SYSTEMS_FORM_COMPONENTS_TYPES = {
  PAN_KEEPER_FORM: 'pan-keeper',
  VOUCHER_CODE: 'voucher-code'
};

export const PAYMENT_SYSTEMS_COMPONENTS_MAP = {
  [PAYMENT_SYSTEMS_FORM_COMPONENTS_TYPES.PAN_KEEPER_FORM]: PanKeeperForm,
  [PAYMENT_SYSTEMS_FORM_COMPONENTS_TYPES.VOUCHER_CODE]: VoucherCodeField
};
